import React from 'react';
import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';
import {
  Tab,
  Row,
  Col,
  Nav,
  NavItem,
} from 'react-bootstrap';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import moment from 'moment';
import {
  querySelector,
} from '../../utils';

import HoursReport from './HoursReport';

const propTypes = exact({
  currentWeeklyTimesheets: PropTypes.array,
  previousWeeklyTimesheets: PropTypes.array,
});

const today = moment(new Date()).subtract(0, 'days');
const todayFmt = today.format('YYYY/MM/DD');
const lastWeekFmt = today.clone().subtract(1, 'week').format('YYYY/MM/DD');


const OvertimeDetails = (props) => {
  const { previousWeeklyTimesheets, currentWeeklyTimesheets } = props;
  return (
    <div>
      <Tab.Container defaultActiveKey={2} id="statusTabs">
        <Row className="clearfix">
          <Col sm={12}>
            <Nav bsStyle="tabs">
              <NavItem eventKey={1}>
                <label>Past Week</label>
              </NavItem>
              <NavItem eventKey={2}>
                <label>Current Week</label>
              </NavItem>
            </Nav>
          </Col>
          <Col sm={12} className="list-scrollbar">
            <Tab.Content animation={false}>
              <Tab.Pane eventKey={1}>
                <HoursReport
                  weekUserTimesheets={previousWeeklyTimesheets}
                />
              </Tab.Pane>
              <Tab.Pane eventKey={2}>
                <HoursReport
                  weekUserTimesheets={currentWeeklyTimesheets}
                />
              </Tab.Pane>
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
    </div>
  );
};


const GET_WEEKLY_TIMESHEETS_HOURS_QUERY = gql`
  query GetWeeklyTimesheets($endDate: String!, $weeksBack: Int) {
    all_timesheets_for_all_users(end_date: $endDate, weeks_back: $weeksBack) {
      edges {
        node {
          id
          start_date {
            iso8601
            display
          }
          end_date {
            display
          }
          out_of_service {
            to_string
            total_seconds
          }
          overtime {
            to_string
            total_seconds
          }
          worked_hours {
            to_string
            total_seconds
            hours
          }
          pto {
            to_string
            total_seconds
          }
          user {
            id
            firstname
            lastname
            payroll_type
            default_district {
              id
              name
            }
            default_department {
              id
              name
            }
          }
        }
      }
    }
  }
`;


const marshallCurrentWeek = ({ data, ownProps }) => {
  const currentWeeklyTimesheets = querySelector(data, '$.all_timesheets_for_all_users.edges[*].node', []);

  return {
    ...ownProps,
    currentWeeklyTimesheets,
  };
};

const marshallPreviousWeek = ({ data, ownProps }) => {
  const previousWeeklyTimesheets = querySelector(data, '$.all_timesheets_for_all_users.edges[*].node', []);

  return {
    ...ownProps,
    previousWeeklyTimesheets,
  };
};

const withApi = compose(
  graphql(GET_WEEKLY_TIMESHEETS_HOURS_QUERY, {
    props: marshallCurrentWeek,
    options: {
      variables: {
        endDate: todayFmt,
        weeksBack: 0,
      },
    },
  }),
  graphql(GET_WEEKLY_TIMESHEETS_HOURS_QUERY, {
    props: marshallPreviousWeek,
    options: {
      variables: {
        endDate: lastWeekFmt,
        weeksBack: 0,
      },
    },
  }),
);

OvertimeDetails.propTypes = propTypes;

export default withApi(OvertimeDetails);
